import React from 'react';
import AMSSyncLogs from './AMSSyncLogs';
import UniversalRowsExport from './UniversalRowsExport';
import { AMS_SYNC_LOGS, UNIVERSAL_ROWS_EXPORT } from '../Tabs/constants';
import { Container } from './Content.styled';

const Content = ({
  selectedTab,
  isAddOrgDrawerVisible,
  setAddOrgDrawerVisibility,
}) => {
  const renderContent = () => {
    switch (selectedTab) {
      case AMS_SYNC_LOGS:
        return (
          <AMSSyncLogs
            isAddOrgDrawerVisible={isAddOrgDrawerVisible}
            setAddOrgDrawerVisibility={setAddOrgDrawerVisibility}
          />
        );
      case UNIVERSAL_ROWS_EXPORT:
        return <UniversalRowsExport />;
      default:
        return null;
    }
  };

  return <Container>{renderContent()}</Container>;
};

export default Content;
